import type { MarkAreaComponentOption } from 'echarts';

export interface MarkAreaInterval {
  readonly startTime: Date;
  readonly endTime: Date;
  readonly phaseName: string;
  readonly borderColor: string;
  readonly backgroundColor: string;
  readonly labelColor: string;
  readonly identifier: string;
  readonly metaData?: Record<string, string | number | undefined>;
}

export function buildLabeledTimeRangeMarkArea(intervals: MarkAreaInterval[]): MarkAreaComponentOption {
  const data = intervals.map((interval) => [
    {
      xAxis: interval.startTime,
      z: -20,
      phaseId: interval.identifier,
      ...(interval.metaData ? { metaData: interval.metaData } : {}),
      itemStyle: {
        color: interval.backgroundColor,
        borderColor: interval.borderColor,
        borderWidth: 1,
        borderType: 'solid' as const,
      },
      emphasis: {
        disabled: true,
        label: {
          position: ['50%', '50%'],
        },
      },
      label: {
        show: true,
        position: ['50%', '50%'],
        rotate: 90,
        distance: 15,
        color: interval.labelColor,
        fontSize: 11,
        fontWeight: 'bold' as const,
        formatter: interval.phaseName,
        align: 'center' as const,
        verticalAlign: 'middle' as const,
      },
    },
    {
      xAxis: interval.endTime,
    },
  ]);

  return { data } as MarkAreaComponentOption;
}
